export const resources = {
  ko: {
    translation: {
      siteDescription: "알리익스프레스에서 핫딜을 놓치지 마세요! 스마트한 쇼핑으로 놀라운 할인 혜택을 누리세요!",
      footerCopyright: "HotAliDeal.com에 게재된 모든 상품 정보와 이미지의 저작권은 AliExpress와 각 판매자에게 있습니다.",
      more: "더보기",
      viewMore: "더보기",
      showMore: "더보기",
      hotDeals: "핫딜 상품",
      all: "전체",
      privacyPolicy: "개인정보 처리방침",
      footerText: "HotAliDeal.com은 제휴 마케팅 활동의 일환으로 수수료를 받을 수 있습니다.",
      menu: "메뉴",
      close: "닫기",
      copy: "복사",
      promoCode: "프로모션 코드",
      copiedPromoCodeMessage: "프로모션 코드가 복사되었습니다.",
      productDescription: "상품 정보",
      relatedItems: "연관 상품",
      buyOnAliExpress: "AliExpress에서 구매",
      sold: "누적 판매",
      expires: "유효기간",
      discount: "할인",
      averageReviewRating: "평균 리뷰 평점",
      search: "검색...",
      searchResults: "{{value}} 개의 검색 결과",
      termsOfService: "서비스 약관",
      about: "사이트 소개",
      reviews: "리뷰",
      checkReviewsOnAliExpress: "AliExpress에서 리뷰 보기",
      productHidden: "판매가 중단된 상품입니다.",
      brands: "브랜드",
      brandsDescription: "알리익스프레스의 모든 브랜드를 한눈에 확인하세요",
      "brands.allBrands": "전체 브랜드",
      category: {
        electronics: "전자제품",
        fashion: "패션",
        home: "홈/가구",
        sports: "스포츠/레저",
        health: "건강/뷰티",
        kids: "키즈/베이비",
        office: "사무용품",
        other: "기타"
      },
      products: "상품",
      productsCapital: "상품",
      promotions: "프로모션",
      allPromotions: "모든 프로모션",
      viewAllPromotions: "모든 프로모션 보기",
      noPromotions: "등록된 프로모션이 없습니다",
      backToPromotions: "프로모션 목록으로 돌아가기",
      promotionsDescription: "알리익스프레스의 최신 프로모션을 확인하세요",
      viewDetails: "상세 보기",
      visitPromotion: "방문하기",
      backToHome: "홈으로 돌아가기",
      notFoundPromotion: "프로모션을 찾을 수 없습니다",
      lastUpdated: "마지막 업데이트",
    }
  },
  en: {
    translation: {
      siteDescription: "Get hot deals on AliExpress and enjoy incredible savings while shopping smarter!",
      footerCopyright: "The copyright for all product information and images on HotAliDeal.com belongs to AliExpress and the respective sellers.",
      more: "More",
      viewMore: "View More",
      showMore: "Show More",
      hotDeals: "Hot Deals",
      all: "All",
      privacyPolicy: "Privacy Policy",
      footerText: "HotAliDeal.com may earn a commission as part of its affiliate marketing activities.",
      menu: "Menu",
      close: "Close",
      copy: "Copy",
      promoCode: "Promo Code",
      copiedPromoCodeMessage: "The promo code has been copied.",
      productDescription: "Description",
      relatedItems: "Related items",
      buyOnAliExpress: "Buy on AliExpress",
      sold: "sold",
      expires: "Expires",
      discount: "Discount",
      averageReviewRating: "Average Review Rating",
      search: "Search...",
      searchResults: "{{value}} results",
      termsOfService: "Terms of Service",
      about: "About",
      reviews: "Reviews",
      checkReviewsOnAliExpress: "Check Reviews on AliExpress",
      productHidden: "This product has been discontinued.",
      brands: "Brands",
      brandsDescription: "Discover all brands on AliExpress at a glance",
      "brands.allBrands": "All Brands",
      category: {
        electronics: "Electronics",
        fashion: "Fashion",
        home: "Home & Furniture",
        sports: "Sports & Leisure",
        health: "Health & Beauty",
        kids: "Kids & Baby",
        office: "Office Supplies",
        other: "Others"
      },
      products: "products",
      productsCapital: "Products",
      promotions: "Promotions",
      allPromotions: "All Promotions",
      viewAllPromotions: "View All Promotions",
      noPromotions: "No promotions available",
      backToPromotions: "Back to Promotions",
      promotionsDescription: "Check out the latest promotions on AliExpress",
      viewDetails: "View Details",
      visitPromotion: "Visit",
      backToHome: "Back to Home",
      notFoundPromotion: "Promotion not found",
      lastUpdated: "Last Updated",
    }
  },
  ja: {
    translation: {
      siteDescription: "アリエクスプレスでお得なセールをお見逃しなく！スマートに買い物して、驚きの割引を楽しもう！",
      footerCopyright: "HotAliDeal.comに掲載されているすべての商品情報と画像の著作権はAliExpressと各販売者に帰属します。",
      more: "もっと見る",
      viewMore: "もっと見る",
      showMore: "もっと見る",
      hotDeals: "お買い得商品",
      all: "すべて",
      privacyPolicy: "プライバシーポリシー",
      footerText: "HotAliDeal.comはアフィリエイトマーケティング活動の一環として手数料を得る場合があります。",
      menu: "メニュー",
      close: "閉じる",
      copy: "コピー",
      promoCode: "プロモーションコード",
      copiedPromoCodeMessage: "プロモーションコードがコピーされました。",
      productDescription: "概要",
      relatedItems: "関連アイテム",
      buyOnAliExpress: "AliExpressで購入",
      sold: "販売済み",
      expires: "有効期限",
      discount: "割引",
      averageReviewRating: "平均レビュー評価",
      search: "検索...",
      searchResults: "{{value}} 件の検索結果",
      termsOfService: "サービス規約",
      about: "サイトについて",
      reviews: "レビュー",
      checkReviewsOnAliExpress: "AliExpressでレビューを見る",
      productHidden: "この商品は廃止されました。",
      brands: "ブランド",
      brandsDescription: "アリエクスプレスのすべてのブランドを一目で確認できます",
      "brands.allBrands": "すべてのブランド",
      category: {
        electronics: "電子機器",
        fashion: "ファッション",
        home: "ホーム＆家具",
        sports: "スポーツ＆レジャー",
        health: "健康＆ビューティー",
        kids: "キッズ＆ベビー",
        office: "オフィス用品",
        other: "その他"
      },
      products: "商品",
      productsCapital: "商品",
      promotions: "プロモーション",
      allPromotions: "全てのプロモーション",
      viewAllPromotions: "全てのプロモーションを見る",
      noPromotions: "プロモーションがありません",
      backToPromotions: "プロモーション一覧に戻る",
      promotionsDescription: "アリエクスプレスの最新プロモーションをチェック",
      viewDetails: "詳細を見る",
      visitPromotion: "訪問する",
      backToHome: "ホームに戻る",
      notFoundPromotion: "プロモーションが見つかりません",
      lastUpdated: "最終更新",
    }
  },
  ru: {
    translation: {
      siteDescription: "Не упустите горячие предложения на AliExpress и наслаждайтесь невероятными скидками, покупая более умно!",
      footerCopyright: "Авторское право на всю информацию о продукте и изображения на HotAliDeal.com принадлежит AliExpress и соответствующим продавцам.",
      more: "Больше",
      viewMore: "Посмотреть больше",
      showMore: "Показать больше",
      hotDeals: "Горячие предложения",
      all: "Все",
      privacyPolicy: "Политика конфиденциальности",
      footerText: "HotAliDeal.com может получать комиссию в рамках своей партнерской маркетинговой деятельности.",
      menu: "Меню",
      close: "Закрыть",
      copy: "Копировать",
      promoCode: "Промо-код",
      copiedPromoCodeMessage: "Промо-код был скопирован.",
      productDescription: "Описание товара",
      relatedItems: "Связанные товары",
      buyOnAliExpress: "Купить на AliExpress",
      sold: "продано",
      expires: "Истекает",
      discount: "Скидка",
      averageReviewRating: "Средний рейтинг отзывов",
      search: "Поиск...",
      searchResults: "{{value}} результатов",
      termsOfService: "Условия использования",
      about: "О нас",
      reviews: "Отзывы",
      checkReviewsOnAliExpress: "Посмотреть отзывы на AliExpress",
      productHidden: "Этот товар был прекращен.",
      brands: "Бренды",
      brandsDescription: "Откройте для себя все бренды на AliExpress одним взглядом",
      "brands.allBrands": "Все бренды",
      category: {
        electronics: "Электроника",
        fashion: "Мода",
        home: "Дом и мебель",
        sports: "Спорт и отдых",
        health: "Здоровье и красота",
        kids: "Дети и младенцы",
        office: "Канцелярские товары",
        other: "Другое"
      },
      products: "товары",
      productsCapital: "Товары",
      promotions: "Акции",
      allPromotions: "Все акции",
      viewAllPromotions: "Посмотреть все акции",
      noPromotions: "Нет доступных акций",
      backToPromotions: "Вернуться к акциям",
      promotionsDescription: "Ознакомьтесь с последними акциями на AliExpress",
      viewDetails: "Подробнее",
      visitPromotion: "Посетить",
      backToHome: "Вернуться на главную",
      notFoundPromotion: "Акция не найдена",
      lastUpdated: "Последнее обновление",
    }
  },
  es: {
    translation: {
      siteDescription: "¡No te pierdas las ofertas de AliExpress y disfruta de increíbles ahorros comprando de forma más inteligente!",
      footerCopyright: "Los derechos de autor de toda la información del producto y las imágenes en HotAliDeal.com pertenecen a AliExpress y a los respectivos vendedores.",
      more: "Más",
      viewMore: "Ver más",
      showMore: "Mostrar más",
      hotDeals: "Ofertas",
      all: "Todos",
      privacyPolicy: "Política de privacidad",
      footerText: "HotAliDeal.com puede ganar una comisión como parte de sus actividades de marketing de afiliados.",
      menu: "Menú",
      close: "Cerrar",
      copy: "Copiar",
      promoCode: "Código promocional",
      copiedPromoCodeMessage: "El código promocional ha sido copiado.",
      productDescription: "Descripción",
      relatedItems: "Productos relacionados",
      buyOnAliExpress: "Comprar en AliExpress",
      sold: "vendido",
      expires: "Caduca",
      discount: "Descuento",
      averageReviewRating: "Calificación promedio de la reseña",
      search: "Buscar...",
      searchResults: "{{value}} resultados",
      termsOfService: "Términos de servicio",
      about: "Acerca de",
      reviews: "Reseñas",
      checkReviewsOnAliExpress: "Ver reseñas en AliExpress",
      productHidden: "Este producto ha sido descontinuado.",
      brands: "Marcas",
      brandsDescription: "Descubre todas las marcas en AliExpress de un vistazo",
      "brands.allBrands": "Todas las marcas",
      category: {
        electronics: "Electrónica",
        fashion: "Moda",
        home: "Hogar y muebles",
        sports: "Deportes y ocio",
        health: "Salud y belleza",
        kids: "Niños y bebés",
        office: "Material de oficina",
        other: "Otros"
      },
      products: "productos",
      productsCapital: "Productos",
      promotions: "Promociones",
      allPromotions: "Todas las promociones",
      viewAllPromotions: "Ver todas las promociones",
      noPromotions: "No hay promociones disponibles",
      backToPromotions: "Volver a promociones",
      promotionsDescription: "Consulta las últimas promociones en AliExpress",
      viewDetails: "Ver detalles",
      visitPromotion: "Visitar",
      backToHome: "Volver al inicio",
      notFoundPromotion: "Promoción no encontrada",
      lastUpdated: "Última actualización",
    }
  }
}; 